import { AuthAxios } from "../../global-config/HttpConfig";
import { ApiURIs } from "../../global-config/ApiList";

export default {
  GetEmployeeForAgent() {
    return AuthAxios.get(ApiURIs.GetEmployeeForAgent);
  }
};
